// src/pages/RoleBasedDashboard.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { useAuth } from '../../contexts/AuthContext';

const RoleBasedDashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const redirectUser = async () => {
      if (!user) {
        navigate('/user-login');
        return;
      }

      // Get role from user_profiles or role_email_authorizations table
      const { data, error } = await supabase?.from('role_email_authorizations')?.select('role')?.eq('email', user?.email)?.maybeSingle();

      if (error) {
        console.error('Error fetching role:', error);
        navigate('/user-login');
        return;
      }

      if (!data?.role) {
        console.warn('No role found for user.');
        navigate('/user-login');
        return;
      }

      // Role-based redirection
      switch (data?.role?.toLowerCase()) {
        case 'student': navigate('/team-workspace');
          break;
        case 'city official': case'city_official': navigate('/city-official-dashboard');
          break;
        case 'pcf admin': case'pcf_admin': navigate('/pcf-admin-dashboard');
          break;
        default:
          navigate('/user-login');
      }

      setLoading(false);
    };

    redirectUser();
  }, [user, navigate]);

  if (loading) return <p>Loading dashboard...</p>;

  return null;
};

export default RoleBasedDashboard;